<div class="appointment-list-container">

    <mat-toolbar color="primary" class="action-toolbar appointment-list-toolbar">
        <h3>Upcoming Appointments</h3>
        <div class="toolbar-filters">
            <button mat-button class="confirm-filter-toggle" [class.active]="calendarConfirmFilter.unconfirmedOnly"
                (click)="setUnconfirmedOnly(!calendarConfirmFilter.unconfirmedOnly)"
                [attr.aria-pressed]="calendarConfirmFilter.unconfirmedOnly"
                matTooltip="Show only bookings still to confirm with the patient">
                <mat-icon>{{ calendarConfirmFilter.unconfirmedOnly ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                <span>Not yet confirmed</span>
            </button>
            <div class="calendar-physician-switcher" *ngIf="calendarLocations.length">
                <button mat-button [matMenuTriggerFor]="locationFilterMenu" matTooltip="Filter by location">
                    <span>{{ calendarLocationFilterButtonLabel }}</span>
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #locationFilterMenu="matMenu" class="calendar-physician-filter-menu">
                    <button mat-menu-item (click)="selectLocationFilterFromMenu(null)">
                        <span>All locations</span>
                    </button>
                    <button mat-menu-item *ngFor="let location of calendarLocations"
                        (click)="selectLocationFilterFromMenu(location.id)">
                        <span>{{ location.name }}</span>
                    </button>
                </mat-menu>
            </div>
            <div class="calendar-physician-switcher" *ngIf="calendarSplitByPhysician">
                <button mat-button [matMenuTriggerFor]="physicianFilterMenu" matTooltip="Filter by physician">
                    <span>{{ calendarPhysicianFilterButtonLabel }}</span>
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #physicianFilterMenu="matMenu" class="calendar-physician-filter-menu">
                    <button mat-menu-item (click)="selectPhysicianFilterFromMenu(null)">
                        <span>Combined</span>
                    </button>
                    <button mat-menu-item *ngFor="let u of doctorUsersForCalendar"
                        (click)="selectPhysicianFilterFromMenu(u.userId)">
                        <span>{{ u.title }} {{ u.name }} {{ u.surname }}</span>
                    </button>
                </mat-menu>
            </div>
        </div>
        <div class="actions">
            <button mat-icon-button color="primary" (click)="addEvent()" matTooltip="Add Event">
                <mat-icon>event</mat-icon>
            </button>
            <button mat-icon-button (click)="openScheduleDialog()" color="primary"
                matTooltip="Schedule Patient"><mat-icon>person_add_alt</mat-icon></button>
        </div>

    </mat-toolbar>

    <div class="appointment-list" (scroll)="onScroll($event)">
        <div class="appointment-info"><ng-container *ngIf="appointments; else listLoading">
                <ng-container *ngIf="appointments.length; else noResults">
                    <ng-container *ngFor="let group of appointments | slice:0:displayedGroupsCount ">
                        <div class="list-header">
                            {{ group.date | date: 'longDate' }}
                        </div>
                        <mat-list class="full-width">
                            <mat-list-item *ngFor="let appointment of group.appointments"
                                (click)="openBooking(appointment)" class="auto-height"
                                [appPatientValidationStatus]="appointment.Patient ?? {}"
                                #valStatus="appPatientValidationStatus" [appPatientActive]="appointment.Patient?.id">
                                <div class="appointment-item stack-mobile">
                                    <div class="flex-row">
                                        <div class="appointment-details">
                                            <ng-container *ngIf="appointment.Patient">
                                                <app-patient-validation-messages [valStatus]="valStatus">
                                                </app-patient-validation-messages>
                                                <div matLine class="patient-name">
                                                    <b>{{ appointment.Patient.surname }}, {{ appointment.Patient.name
                                                        }}</b>
                                                    <span class="patient-number"
                                                        *ngIf="appointment.Patient.patientNumber">({{
                                                        appointment.Patient.patientNumber
                                                        }})</span>
                                                    <span class="practice-name" *ngIf="appointment.practiceName">{{ appointment.practiceName }}</span>
                                                </div>
                                                <div matLine class="patient-diagnosis">
                                                    <span>{{ appointment.Patient.diagnosis }}</span>
                                                </div>
                                                <div matLine *ngIf="appointment.Patient.diagnosis2"
                                                    class="patient-diagnosis">
                                                    <span>{{ buildDiagnosisString(appointment.Patient) }}</span>
                                                </div>

                                                <div matLine class="patient-diagnosis" *ngIf="appointment.procedure">
                                                    <span>Procedure: {{ appointment.procedure }}</span>
                                                </div>
                                                <div matLine class="patient-diagnosis"
                                                    *ngIf="appointment.reasonForVisit">
                                                    <span>{{ appointment.reasonForVisit }}</span>
                                                </div>
                                                <div matLine class="patient-diagnosis"
                                                    *ngIf="appointment.Patient.reasonForVisiting">
                                                    <span>{{ appointment.Patient.reasonForVisiting }}</span>
                                                </div>
                                            </ng-container>

                                            <ng-container *ngIf="!appointment.Patient">
                                                <div matLine class="patient-name">
                                                    <b>{{ appointment.reason }}</b>
                                                </div>
                                            </ng-container>


                                            <div matLine class="appointment-footer">
                                                <div class="full-height">
                                                    <span class="appointment-type"
                                                        [matTooltip]="appointment.typeDetails.type"
                                                        [ngStyle]="{'background-color': appointment.typeDetails.backgroundColor,'color': appointment.typeDetails.textColor, 'border': appointment.typeDetails.borderColor ? '2px solid ' + appointment.typeDetails.borderColor : '2px solid ' + appointment.typeDetails.backgroundColor }">
                                                    </span>
                                                </div>
                                                <ng-container *ngIf="appointment.isAllDay">
                                                    <span>All Day</span>
                                                </ng-container>
                                                <ng-container *ngIf="!appointment.isAllDay">
                                                    {{

                                                    (appointment.date.substring(0,10) + 'T' + appointment.timeSlot) |
                                                    date:
                                                    'HH:mm'}}{{appointment.endSlot ? ' - ' + appointment.endSlot : ''}}
                                                </ng-container>
                                                {{appointment.appointmentType}}{{appointment.virtualLink ? ' (Virtual)'
                                                : ''}} <span *ngIf="appointment.procedure">-
                                                    {{appointment.procedure}}</span>
                                                <span class="confirmed-chip" *ngIf="appointment.confirmedAt && !appointment.reason"
                                                    [matTooltip]="confirmationTooltip(appointment)">
                                                    <mat-icon>event_available</mat-icon>Confirmed</span>
                                            </div>

                                            <ng-container
                                                *ngIf="appointment.Patient && (appointment.patientArrivedTime || appointment.endTime)">
                                                <span class="hint" *ngIf="appointment.patientArrivedTime">Arrived: {{
                                                    appointment.patientArrivedTime | dateDiff }}
                                                    ago </span>
                                                <span class="hint" *ngIf="appointment.endTime">
                                                    <span class="hint" *ngIf="appointment.patientArrivedTime">|
                                                    </span>Completed: {{
                                                    appointment.endTime | dateDiff }}
                                                    ago </span>
                                                <span class="hint"
                                                    *ngIf="appointment.patientArrivedTime && appointment.endTime">
                                                    ({{ appointment.patientArrivedTime |
                                                    dateDiff:appointment.endTime }})</span>
                                            </ng-container>


                                        </div>
                                        <div class="actions">
                                            <button mat-icon-button *ngIf="appointment.virtualLink"
                                                (click)="loadVirtualLink(appointment, $event)"
                                                matTooltip="Open the virtual meeting link in a new tab">
                                                <mat-icon>videocam</mat-icon>
                                            </button>
                                            <ng-container *ngIf="shouldShowStatusMenu(appointment)">
                                                <button mat-icon-button [matMenuTriggerFor]="appointmentMenu"
                                                    (click)="$event.stopPropagation()"
                                                    matTooltip="Set Appointment Status">
                                                    <mat-icon>more_vert</mat-icon>
                                                </button>
                                                <mat-menu #appointmentMenu="matMenu">
                                                    <button mat-menu-item *ngIf="needsConfirming(appointment)"
                                                        (click)="updateAppointmentStatus(appointment, 'confirmed', $event)"
                                                        matTooltip="The patient has confirmed this booking">
                                                        <mat-icon class="confirmed-icon">event_available</mat-icon>
                                                        <span>Confirmed</span>
                                                    </button>
                                                    <button mat-menu-item *ngIf="canUnconfirm(appointment)"
                                                        (click)="updateAppointmentStatus(appointment, 'not_confirmed', $event)"
                                                        [matTooltip]="confirmationTooltip(appointment)">
                                                        <mat-icon>event_busy</mat-icon>
                                                        <span>Not Confirmed</span>
                                                    </button>
                                                    <mat-divider
                                                        *ngIf="needsConfirming(appointment) || canUnconfirm(appointment)"></mat-divider>
                                                    <button mat-menu-item *ngIf="shouldShowArrivedOption(appointment)"
                                                        (click)="updateAppointmentStatus(appointment, 'arrived', $event)"
                                                        matTooltip="Mark patient as arrived">
                                                        <mat-icon>check_circle</mat-icon>
                                                        <span>Arrived</span>
                                                    </button>
                                                    <button mat-menu-item
                                                        *ngIf="shouldShowNotArrivedOption(appointment)"
                                                        (click)="updateAppointmentStatus(appointment, 'not_arrived', $event)"
                                                        matTooltip="Mark patient as not arrived">
                                                        <mat-icon>schedule</mat-icon>
                                                        <span>Not Arrived</span>
                                                    </button>
                                                    <mat-divider
                                                        *ngIf="shouldShowArrivedOption(appointment) || shouldShowNotArrivedOption(appointment)"></mat-divider>
                                                    <button mat-menu-item *ngIf="shouldShowCancelledOption(appointment)"
                                                        (click)="updateAppointmentStatus(appointment, 'cancelled', $event)"
                                                        matTooltip="Cancel this appointment">
                                                        <mat-icon>cancel</mat-icon>
                                                        <span>Cancelled</span>
                                                    </button>
                                                    <button mat-menu-item
                                                        *ngIf="shouldShowNotCancelledOption(appointment)"
                                                        (click)="updateAppointmentStatus(appointment, 'not_cancelled', $event)"
                                                        matTooltip="Uncancel this appointment">
                                                        <mat-icon>restore</mat-icon>
                                                        <span>Not Cancelled</span>
                                                    </button>
                                                    <mat-divider
                                                        *ngIf="shouldShowCancelledOption(appointment) || shouldShowNotCancelledOption(appointment)"></mat-divider>
                                                    <button mat-menu-item
                                                        *ngIf="shouldShowDidNotAttendOption(appointment)"
                                                        (click)="updateAppointmentStatus(appointment, 'did_not_attend', $event)"
                                                        matTooltip="Mark patient as did not attend">
                                                        <mat-icon>person_off</mat-icon>
                                                        <span>Did Not Attend</span>
                                                    </button>
                                                    <button mat-menu-item *ngIf="shouldShowDidAttendOption(appointment)"
                                                        (click)="updateAppointmentStatus(appointment, 'did_attend', $event)"
                                                        matTooltip="Mark patient as did attend">
                                                        <mat-icon>person</mat-icon>
                                                        <span>Did Attend</span>
                                                    </button>
                                                </mat-menu>
                                            </ng-container>
                                            <ng-container *ngIf="shouldShowDoctorCompletionMenu(appointment)">
                                                <button mat-icon-button [matMenuTriggerFor]="doctorMenu"
                                                    (click)="$event.stopPropagation()" matTooltip="Doctor Actions">
                                                    <mat-icon>medical_services</mat-icon>
                                                </button>
                                                <mat-menu #doctorMenu="matMenu">
                                                    <button mat-menu-item (click)="markNoteAsSaved(appointment, $event)"
                                                        matTooltip="Mark note as saved">
                                                        <mat-icon>note_add</mat-icon>
                                                        <span>Mark Note as Saved</span>
                                                    </button>
                                                </mat-menu>
                                            </ng-container>
                                            <button mat-icon-button (click)="rescheduleAppointment(appointment, $event)" *ngIf="!appointment.practiceName"
                                                [matTooltip]="appointment.reason ? 'Edit Event' : 'Reschedule Appointment'">
                                                <mat-icon>edit_calendar</mat-icon>
                                            </button>
                                            <button mat-icon-button matTooltip="View Patient"
                                                *ngIf="!appointment.reason">
                                                <mat-icon>visibility</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                    <div *ngIf="!appointment.reason" class="appointment-status" matTooltip="{{ 
                                        appointment.isCancelled === true ? 'Appointment cancelled' :
                                        appointment.didNotAttend === true ? 'Patient did not attend' :
                                        appointment.patientArrivedTime == null && appointment.startTime == null && appointment.endTime == null ? 'No activity yet' :
                                        appointment.patientArrivedTime !== null && appointment.endTime == null ? 'This patient has arrived' :
                                        appointment.startTime !== null && appointment.endTime === null ? 'Appointment in progress' :
                                        appointment.endTime !== null && appointment.noteSaved === false ? 'Appointment completed. Note not saved to timeline' : 
                                        appointment.endTime !== null && appointment.noteSaved === true ? 'Appointment completed. Note saved to timeline' : ''
                                    }}" [class.default]="appointment.patientArrivedTime == null && appointment.startTime == null && appointment.endTime == null && appointment.isCancelled !== true && appointment.didNotAttend !== true"
                                        [class.arrived]="appointment.patientArrivedTime !== null && appointment.endTime == null && appointment.isCancelled !== true && appointment.didNotAttend !== true"
                                        [class.busy]="((appointment.startTime !== null && appointment.endTime === null) || (appointment.endTime !== null && appointment.noteSaved === false)) && appointment.isCancelled !== true && appointment.didNotAttend !== true"
                                        [class.completed]="((appointment.endTime !== null && appointment.noteSaved == null) || appointment.noteSaved) && appointment.isCancelled !== true && appointment.didNotAttend !== true"
                                        [class.cancelled]="appointment.isCancelled === true"
                                        [class.did-not-attend]="appointment.didNotAttend === true">
                                    </div>
                                </div>

                            </mat-list-item>
                        </mat-list>
                    </ng-container>
                    <!-- <div *ngIf="appointments.length > displayedGroupsCount" class="loading-more">
                        <mat-spinner diameter="24" color="accent"></mat-spinner>
                    </div> -->
                </ng-container>
            </ng-container>
        </div>
        <div class="mobile-spacer"></div>
    </div>

</div>

<ng-template #listLoading>
    <div class="list-loading">
        <mat-spinner color="primary" mode="indeterminate" diameter="20" style="float:right;"></mat-spinner>
    </div>
</ng-template>

<ng-template #noResults>
    <p class="no-records-message">No appointments found.</p>
</ng-template>